import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import { selector as commonSelector } from '@store/common';
import { selector as filterContainerSelector } from '@store/filterContainer';
import {
  applyFilter,
  changeFilterContainerVisibility,
  updateActiveTab,
  updateFilterConditions,
} from '@store/filterContainer/actions';

import FilterDropdown from './FilterDropdown';

const selector = createSelector(
  commonSelector,
  filterContainerSelector,
  (commonStore, filterContainerStore) => ({
    filterColor: commonStore.filterColor,
    isGrandfatherFilter: commonStore.isGrandfatherFilter,
    appliedFilter: commonStore.appliedFilters[0],
    filters: filterContainerStore.filters,
    visible: filterContainerStore.visible,
  }),
);

export default connect(selector, {
  applyFilter,
  changeFilterContainerVisibility,
  updateActiveTab,
  updateFilterConditions,
})(FilterDropdown);
